import axios from 'axios';
import { get } from './utils/request';

const { Conflux, format } = require('js-conflux-sdk');
const Eth = require('ethjs')
const Web3 = require('web3');

const cfx = new Conflux({
    url: 'https://main.confluxrpc.com',
    networkId: 1029,
    defaultGasPrice: 1000000,
    defaultGas: 1000000,
    logger: console,
  });

window.confluxJS = cfx
window.confluxJS.provider = window.conflux




const Big = require('big.js')
//var debug_model = window.conflux.chainId == '0x405' ? false : true
var debug_model = false

var defaultGasPrice = 1000000

//测试合约地址
// const contractAddress = {
//     "nft": "cfxtest:type.contract:acfs2s9be4mfjhmcbc0j8ws79dn0nycsx64wrn9n39",
//     "exchange": "cfxtest:type.contract:ach33fwrft3c9twtptb0ectysjhyunuspuc9s6yp76",
//     "auction": "cfxtest:type.contract:achrrh3ndayuax5zkm6nne6mgxjghwj6mjcpfxrhsh",
//     "oracle": "cfxtest:type.contract:acgu8f87xneh4esz3w4c06z1b5c949xw1247jmpj79",
//     "confi": "cfx:acc370g3s6d56ndcp8t6gyc657rhtp0fz6ytc8j9d2"
// }

//正式合约地址
const contractAddress = debug_model ? {
    "nft": "cfxtest:type.contract:acfs2s9be4mfjhmcbc0j8ws79dn0nycsx64wrn9n39",
    "exchange": "cfxtest:type.contract:ach33fwrft3c9twtptb0ectysjhyunuspuc9s6yp76",
    "auction": "cfxtest:type.contract:achrrh3ndayuax5zkm6nne6mgxjghwj6mjcpfxrhsh",
    "oracle": "cfxtest:type.contract:acgu8f87xneh4esz3w4c06z1b5c949xw1247jmpj79",
    "confi": "cfx:acc370g3s6d56ndcp8t6gyc657rhtp0fz6ytc8j9d2"
} : {
    "nft": "cfx:type.contract:acex90xkzw6zxc7ttmdhxwpmue0777sw0epe0mh8ap",
    "exchange": "cfx:type.contract:ace0s2mwu1am37hnmg9k7pmmcwzsc8smmjmgea4vyy",
    "auction": "CFX:TYPE.CONTRACT:ACEUE9YY6J9VAAGDYT1X7K277H6DHC5E525T4W6R5W",
    "oracle": "cfx:type.contract:acbr5rgyuekaw2y4vr83h4hncj7n6dn0c6h4d6uhnx",
    "confi": "cfx:acc370g3s6d56ndcp8t6gyc657rhtp0fz6ytc8j9d2",
    "blindbox": "cfx:aca4bhc9afhxxbxtmsu5kybdajvve8trby9d0kjvzr"
}

const abis = {
  "nft721": require('./assets/abi/721.json'),
  "nft": require('./assets/abi/TsArt.json'),
  "exchange": require('./assets/abi/FixedExchangeV2.json'),
  "auction": require('./assets/abi/EnglishExchange.json'),
  "oracle": require('./assets/abi/PriceOracle.json'),
  "token": require('./assets/abi/currency.json'),
  "currency": require('./assets/abi/currency.json'),
  "confi": require('./assets/abi/confi.json'),
  "blindbox": require('./assets/abi/TSpaceMestryBoxMarket.json')
}

export async function connectPortal() {
  
    var accounts = await window.conflux.request({method: "cfx_requestAccounts"});

    var account = accounts[0];

    localStorage.setItem('account', account) 
    //调用后端登录接口，获取 token
    
    // try {
    //   await window.API.systemToken.getToken.request({
    //       "walletAddress": account
    //   }).then(async res => {
    //       if(0 == res.data.code) {
            
    //         localStorage.setItem('token', res.data.token) 
            
    //       }
    //   })

    // } catch(e) {
    //   console.log(e)
    // }
    

    return account;
}

export async function connectMetamask() {
  
  var accounts = await window.ethereum.request({method: "eth_requestAccounts"});

  var account = accounts[0];

  localStorage.setItem('account', account) 

  return account;
}

function packageData(list) {
    var plist = [];
    for(var i = 0 ; i < list.length; i++) {
        let heightBid = list[i]['maxBid'] ? list[i]['maxBid']?.price + " " + list[i]['listing']['tokenName'] : ""
        let jo = {
            id: list[i]['id'],
            title: list[i]['name'],
            img: list[i]['image'],
            tokenId: list[i]['tokenId'],
            contractAddress: list[i]['contractAddress'],
            currentStatus: list[i]['currentStatus'],
            heightBid: heightBid
        }

        plist.push(jo);

    }
    return plist;
}

function packageCollectibleData(list) {
    var plist = [];
    for(var i = 0 ; i < list.length; i++) {
        let heightBid = list[i]['maxBid'] ? list[i]['maxBid']?.price + " " + list[i]['listing']['tokenName'] : ""
        //tokenId 过长处理
        let jo = {
            id: list[i]['id'],
            title: list[i]['name'],
            img: list[i]['image'],
            tokenId: list[i]['tokenId']?.length > 5 ? (list[i]['tokenId'].substring(0,3) + "..") : list[i]['tokenId'],
            contractAddress: list[i]['contractAddress'],
            currentStatus: list[i]['currentStatus'],
            heightBid: '',
            method: list[i].listing?.method,
            tokenName: list[i].listing?.tokenName,
            minimumBid: list[i].listing?.minimumBid,
            highestBid: list[i]?.maxBid?.price,
            price: list[i].listing?.price,
            name: list[i].name?.length > 10 ? (list[i].name.substring(0,9) + "..") : list[i].name,
            expirationTime: list[i].listing?.expirationTime

        }

        plist.push(jo);

    }
    return plist;
}
function packageBoxDetailData(record) {
    
  let res = {}

  res['uid'] = record.orderId
  res['createAddress'] = record.createAddress
  res['owner'] = record.owner
  res['nftContract'] = record?.nftContract
  res['image'] = record?.image
  res['isSystem'] = record.isSystem
  res['maxPurchaseOnce'] = record.maxPurchaseOnce
  res['number'] = record.number
  res['onlineOrNot'] = record.onlineOrNot
  res['projectIntroduction'] = record.projectIntroduction
  res['projectParty'] = record.projectParty
  res['residualQuantity'] = record.residualQuantity
  res['seriesName'] = record.seriesName
  res['sort'] = record.sort
  res['ticketId'] = record.ticketId
  res['tokenContract'] = record.tokenContract
  res['tokenContractName'] = record.tokenContractName
  res['totalCirculation'] = record.totalCirculation
  res['unitPrice'] = record?.unitPrice
  res['tokenId'] = record?.ticketId


  return res;
}

function packageDetailData(record) {
    
    let res = {}

    res['uid'] = record.listing?.id
    res['creator'] = record.creator
    res['owner'] = record.owner
    res['assetAddress'] = record?.listing?.assetAddress
    res['contractAddress'] = record?.contractAddress
    res['currencyAddress'] = record.listing?.currencyAddress
    res['tokenName'] = record.listing?.tokenName
    res['name'] = record.name
    res['tokenId'] = record.tokenId
    res['valid'] = record.valid
    res['image'] = record.image
    res['price'] = record.listing?.price
    res['minimumBid'] = record.listing?.minimumBid
    res['method'] = record.listing?.method
    res['taker'] = record.listing?.taker
    res['operator'] = record.listing?.operator
    res['orderType'] = record.listing?.orderType
    res['timeStamp'] = record?.listing?.timeStamp
    res['signData'] = record?.listing?.signData
    res['tokenId'] = record?.tokenId
    res['orderHash'] = record?.listing?.orderHash
    res['expirationTime'] = record?.listing?.expirationTime
    res['privateMetaData'] = record?.privateMetaData?.uri

    return res;
}

function jsonToTuple (jsonInput) {
    const tupleOutput = [];
    for (const key in jsonInput) {
      tupleOutput.push(jsonInput[key]);
    }
    return tupleOutput;
}

    
const nft_contract = window.conflux && window.confluxJS.Contract({
        address: contractAddress.nft,
        abi: abis.nft.abi
    });
const PriceContract = window.conflux && window.confluxJS.Contract({
  address: contractAddress.oracle,
  abi: abis.oracle.abi
});

async function setApprovalForAll(sender, operator, approved) {
    
    var result = await nft_contract
    .setApprovalForAll(operator, approved)
    .sendTransaction({from: sender, gasPrice: defaultGasPrice})
    .confirmed();

    return result;
}

async function setApprovalForThis(sender, operator, approved, address ) {
  const contract = window.conflux && window.confluxJS.Contract({address: address, abi: abis.nft.abi})
  return await contract
    .setApprovalForAll( toHex(operator), approved)
    .sendTransaction({from: sender, gasPrice: defaultGasPrice})
    .executed();
}

async function isApprovedForAll(account, operator) {
    var result = await nft_contract
    .isApprovedForAll(account, operator)

    return result;
}

async function isApprovedForThis(account, operator, nftAddress) {
  const contract = window.conflux && window.confluxJS.Contract({address: nftAddress, abi: abis.nft.abi})
  var result = await contract
  .isApprovedForAll(account, operator)

  return result;
}

async function signature(order, type, callback) {
    
    const typeData = orderSign(order, type)
    console.log("typeData", typeData)
    
    try {
      let accounts = await window.conflux.request({method: "cfx_accounts"})
      let sAddress = accounts[0]
      let params = [toHex( sAddress ), JSON.stringify(typeData)]

      await window.conflux.request({
          method: 'eth_signTypedData_v4',
          params
      }).then((result) => {
        
        callback(null, result)
      }).catch((error) => {
        
        callback(error, null)
      })
      // window.conflux.request({
      //     method: 'eth_signTypedData_v4',
      //     [toHex( window.conflux.selectedAddress), JSON.stringify(typeData)]
      // }, function(err, res) {
      //   console.log(err, res)
      //     callback(err, res);
      // })
    } catch(e) {
      console.log(e)
    }
    


}

function orderSign(orderData, type) {
    const domain = [
        { name: 'name', type: 'string' },
        { name: 'version', type: 'string' },
        { name: 'chainId', type: 'uint256' },
        { name: 'verifyingContract', type: 'address' },
      ]
      const order =
        type === 'auction'
          ? [
              { name: 'owner', type: 'address' },
              { name: 'taker', type: 'address' },
              { name: 'operator', type: 'address' },
              { name: 'orderType', type: 'uint256' },
              { name: 'uid', type: 'uint256' },
              { name: 'startPrice', type: 'uint256' },
              { name: 'endTime', type: 'uint256' },
              { name: 'salt', type: 'uint256' },
              { name: 'assetAddress', type: 'address' },
              { name: 'id', type: 'uint256' },
              { name: 'currencyAddress', type: 'address' },
              { name: 'feeRecipient', type: 'address' },
              { name: 'feePercentage', type: 'uint256' },
            ]
          : [
              { name: 'owner', type: 'address' },
              { name: 'taker', type: 'address' },
              { name: 'operator', type: 'address' },
              { name: 'orderType', type: 'uint256' },
              { name: 'uid', type: 'uint256' },
              { name: 'startPrice', type: 'uint256' },
              { name: 'salt', type: 'uint256' },
              { name: 'assetAddress', type: 'address' },
              { name: 'id', type: 'uint256' },
              { name: 'currencyAddress', type: 'address' },
              { name: 'feeRecipient', type: 'address' },
              { name: 'feePercentage', type: 'uint256' },
            ]
      const orderTemplate = {
        types: {
          EIP712Domain: domain,
          Order: order,
        },
        primaryType: 'Order',
        domain: {
          name: 'ConfiExchange',
          version: '1.0',
          chainId: window.conflux.chainId,
          verifyingContract:
            type === 'auction' ? toHex( contractAddress.auction) : toHex(contractAddress.exchange),
        },
        message: orderData,
      }
      return orderTemplate
}

function getId() {
    return axios.post('/system/getId', {}, {
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': 'X-Requested-With,Content-Type',
            'Access-Control-Allow-Methods': 'PUT,POST,GET,DELETE,OPTIONS'
        }
    })
}


async function getBalance(userAddress, currencyAddress) {
  
  if(toHex( "cfx:aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa0sfbnjm2") == toHex(currencyAddress)) {
    const balance = await window.confluxJS.getBalance(userAddress);

    return balance ? Big(Big(balance).div(1e18).toFixed(2)) : '-'
  } else {
    const currencyCon =
    window.conflux &&
    window.confluxJS.Contract({
      address: currencyAddress,
      abi: abis.token.abi
    })

    const res = await currencyCon.balanceOf(userAddress)
    
    return res ? Big(Big(res).div(1e18).toFixed(2)) : '-'
  }
    

}

async function getEthBalance(userAddress, currencyAddress) {
  
  if(toHex( "0x0000000000000000000000000000000000000000") == toHex(currencyAddress)) {
    const balance = await window.ethereum.request({method: "eth_getBalance", params: [userAddress, 'latest']} );

    return balance ? Big(Big(parseInt(balance)).div(1e18).toFixed(2)) : '-'
  } else {
    const eth = new Eth(new Eth.HttpProvider('https://evm.confluxrpc.com'));
    const currencyCon = eth.contract(abis.token.abi).at(currencyAddress);

    const res = await currencyCon.balanceOf(userAddress);

    return res ? Big(Big(parseInt(res[0].toString(10))).div(1e18).toFixed(2)) : '-'
  }
    

}


function isZeroAddress(address) {
  if(address && toHex(address) == "0x0000000000000000000000000000000000000000") {
    return true;
  }

  return false;
}

function toHex(address) {
    
    if(address)
        return format.hexAddress(address);
    return "";
}

function setException(exception, that) {
    
    if(null != exception && -32603 == exception.code) {
        that.$refs.appHeader.login()
    } else if(null != exception &&4001 == exception.code) {
      that.$h.notify.push(that.$i18n.locale == 'en' ? "User Reject" : "用户拒绝", builder => {
          builder
            .setType("warning")
        })
      .then(() => {
        console.log("resolved");
      });
    } else {
      that.$h.notify.push(exception.message + "", builder => {
          builder
            .setType("warning")
        })
      .then(() => {
        console.log("resolved");
      });
    }

    
}

/**
 * 买家授权代币额度
 * @param currencyAddress 代币地址
 * @param address 被授权地址
 * @param amount 授权额度
 * @param sender 授权地址
 */
 async function approvalPay(currencyAddress, address, price, sender)  {
   console.log(currencyAddress, address, price, sender)
    let amount = Big(price).times(1e18).toFixed()
    // 代币合约
    const currencyCon =
      window.conflux &&
      window.confluxJS.Contract({
        address: currencyAddress,
        abi: abis.currency.abi
      })
    // 获取已授权额度
    let allowanceRes = await currencyCon.allowance(
      toHex(sender),
      toHex(address)
    )

    let allowance = Big(allowanceRes).times(1).toFixed()
    console.log(allowance)

    console.log("已授权额度", allowance, amount, (allowance / 1e18 >= amount / 1e18))
    let result = null

    if (allowance / 1e18 >= amount / 1e18 ) {
        
      result = true
    } else {
      if (allowance == 0) {
        
        try {
          result = await currencyCon.approve(
            toHex(address),
            Big(100000000).times(1e18).toFixed()
          )
          .sendTransaction({ from: sender, gas: 10000000, gasPrice: defaultGasPrice })
          .confirmed()
        } catch(e) {
          result = e
        }
        
        
        
      } else {
        result = await currencyCon
          .approve(toHex(address), Big(0).times(1e18).toFixed() )
          .sendTransaction({ from: sender, gas: 10000000 , gasPrice: defaultGasPrice})
          .confirmed()
        return false
      }
    }

    return result
  }

  function dealTime(nowExpirationTime) {
    if(!nowExpirationTime) return '';
    
    let nowtime = new Date()

    let lefttime = new Date(nowExpirationTime.replace(/-/g, '/')).getTime() - nowtime.getTime()
    
    let leftd,lefth,leftm,lefts

    if(lefttime >= 0) {
      leftd = addZero( Math.floor(lefttime/(1000*60*60*24)) )
      lefth = addZero( Math.floor(lefttime/(1000*60*60)%24) )
      leftm = addZero( Math.floor(lefttime/(1000*60)%60) )
      lefts = addZero( Math.floor(lefttime/1000%60) )
    } else {
      leftd = '00'
      lefth = '00'
      leftm = '00'
      lefts = '00'
    }
    
    return '00' == leftd ? lefth+":"+leftm+":"+lefts : leftd+":"+lefth+":"+leftm+":"+lefts;
    
  }

  function formateDate(timeStamp) {
    const now = new Date(timeStamp)
    const year = now.getFullYear()
    const month = now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : now.getMonth() + 1
    const date = now.getDate() < 10 ? '0' + now.getDate() : now.getDate()
    const hour = now.getHours() < 10 ? '0' + now.getHours() : now.getHours()
    const minute = now.getMinutes() < 10 ? '0' + now.getMinutes() : now.getMinutes()
    const second = now.getSeconds() < 10 ? '0' + now.getSeconds() : now.getSeconds()
    return year + '-' + month + '-' + date + ' ' + hour + ':' + minute + ':' + second
  }

  async function tokenToUsdt(amount, currencyAddress) {
    if (!amount) return '-'
    const res = await PriceContract.tokenToUsdtPrice(
      new Big(amount).times(1e6).toFixed(),
      toHex(currencyAddress)
    )
    return res ? Big(res).times(1/1e6).toFixed(2) : '-'
  }

  function addZero(num) {
    if(parseInt(num) < 10) {
      num = "0" + num;
    }

    return num;
  }

  //处理资源格式
  function assetsType(fileUrl) {
    if(!fileUrl) return 'image'

    var fileName = fileUrl;
    var Ttype = '';
    let suffix = '';
    let result = '';
    const flieArr = fileName.split('.');
    suffix = flieArr[flieArr.length - 1];
    
    if(suffix != "") {
      suffix = suffix.toLocaleLowerCase();
      // 格式
      const imglist = ['png', 'gif', 'wbep', 'svg', 'jpg', 'jpeg'];
      const videoList = ['mp4', 'mp3']
      // 进行匹配
      let result = imglist.find(item => item === suffix);

      if (result) {
        Ttype='image';
      }

      let result2 = videoList.find(item => item === suffix);

      if(result2) {
        Ttype = 'video'
      }

    }
    return Ttype;
  }

  function transferToken(tokenAddress, sender, recipient, amount) {
    
    if(tokenAddress != "cfx:aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa0sfbnjm2") {
      
      const contract =
        window.conflux &&
        window.confluxJS.Contract({
          address: tokenAddress,
          abi: abis.token.abi
        })
      return contract
        .transfer(
          toHex(recipient),
          Big(null == amount ? 0 : amount).times(1e18).toFixed()
        )
        .sendTransaction({ from: toHex(sender)})
        .executed()
    } else {
      
      return window.confluxJS.sendTransaction({
        from: sender,
        to: recipient,
        value: Big(null == amount ? 0 : amount).times(1e18).toFixed()
      }).executed()
    }
    
      
  }

  function transferEthToken(tokenAddress, sender, recipient, amount) {
    
    if(tokenAddress != "0x0000000000000000000000000000000000000000") {

      try {
        const web3 = new Web3('https://evm.confluxrpc.com')

        const currencyCon = new web3.eth.Contract(abis.token.abi, tokenAddress);
        let data = currencyCon.methods.transfer(recipient, web3.utils.toWei(amount, 'ether')).encodeABI();

        const params = {
          to: tokenAddress,
          from: sender,
          data: data,
          chainId: web3.utils.toHex('1030')
        }
        return window.ethereum.request({
          method: 'eth_sendTransaction',
          params: [params]
        });
        
      } catch(e) {
        console.log(e)
      }
      
    } else {
      
      let transactionParameters = {
        from: sender,
        to: recipient,
        value: "0x" + parseInt(Big(null == amount ? 0 : amount).times(1e18)).toString(16)
      }
      return window.ethereum.request({
        method: "eth_sendTransaction",
        params: [transactionParameters]
        
      })
    }
    
      
  }

  

  function transfer(assetAddress, sender, recipient, tokenId, nftType) {
    
    try {
      if("3" != nftType ) {
        const contract =
        window.conflux &&
        window.confluxJS.Contract({
          address: assetAddress,
          abi: abis.nft.abi
        })
      return contract
        .safeTransferFrom(
          toHex(sender),
          toHex(recipient),
          tokenId,
          1,
          Buffer.from('', 'hex')
        )
        .sendTransaction({ from: toHex(sender), gasPrice: defaultGasPrice })
        .confirmed()
      }
  
      if("3" == nftType) {
        const contract =
        window.conflux &&
        window.confluxJS.Contract({
          address: assetAddress,
          abi: abis.nft721
        })
        
      return contract
        .safeTransferFrom(
          toHex(sender),
          toHex(recipient),
          tokenId
        )
        .sendTransaction({ from: toHex(sender), gasPrice: defaultGasPrice })
        .confirmed()
      }
    } catch(e) {
      console.log(e)
      return e;
    }
    
    
  }

  function objectEmpty(obj){

    if(null != obj ) return false;

    for (let key in obj){
      
      return false;
    }
    return true;
  }

  function addTask(taskObj, transactionHash, logType, callback) {
    //将任务添加到队列中
    var taskList = JSON.parse(localStorage.getItem('taskList'))
    
    if(null == taskList || !taskList) {
      taskList = []
      taskList.push(transactionHash)
    } else {
      //检测是否已存在，当前hash
      for(let index in taskList) {
        if(transactionHash == taskList[index]) {
          break;
        }
      }
      taskList.push(transactionHash)
    }
    localStorage.setItem("taskList", JSON.stringify(taskList))

    if(taskList.length > 0) {
      taskObj.$refs.progressDialog.show(taskList.length + " Pending")
    } else{
      taskObj.$refs.progressDialog.hide()
    }

    
    setTimeout(function() {
      if(logType) {
        checkNormalOrderStatus(taskObj, transactionHash, logType, callback)
      } else {
        checkBoxOrderStatus(taskObj, transactionHash, callback)
      }
      
    }, 10)


  }

  function checkBoxOrderStatus(taskObj, hash, callback) {
    window.API.box.getOrderStatus.request({transactionHash: hash}).then(res => {
      console.log("盲盒列表", res)
      if(0 == res.data.code) {
        if(1 == res.data.data.status) {
          //移除任务队列
          var taskList = JSON.parse(localStorage.getItem('taskList'))
          
          for(let index in taskList) {
            if(hash == taskList[index]) {
              taskList.splice(index, 1)
              
              localStorage.setItem("taskList", JSON.stringify(taskList))

              if(taskList.length > 0) {
                taskObj.$refs.progressDialog.show(taskList.length + " Pending")
              } else{
                taskObj.$refs.progressDialog.hide()
              }

            }
          }

          callback()

        } else {
          checkBoxOrderStatus(taskObj, hash, callback)
        }
        
      }

    })
  }

  function checkNormalOrderStatus(taskObj, hash, logType, callback) {
    window.API.trading.getOrderStatus.request({transactionHash: hash, logType: logType}).then(res => {
      console.log("盲盒列表", res)
      if(0 == res.data.code) {
        if(1 == res.data.data.status) {
          //移除任务队列
          var taskList = JSON.parse(localStorage.getItem('taskList'))
          
          for(let index in taskList) {
            if(hash == taskList[index]) {
              taskList.splice(index, 1)
              
              localStorage.setItem("taskList", JSON.stringify(taskList))

              if(taskList.length > 0) {
                taskObj.$refs.progressDialog.show(taskList.length + " Pending")
              } else{
                taskObj.$refs.progressDialog.hide()
              }

            }
          }

          callback()

        } else {
          checkNormalOrderStatus(taskObj, hash, logType, callback)
        }
        
      }

    })
  }

  function queryApproveList(tag, accountAddress) {
    let params = {

    }

    if("conflux" == tag) {
      return get('https://api.confluxscan.io/account/approvals?account=' + accountAddress)
    }

    if("espace" == tag) {
      return get('https://evmapi.confluxscan.io/account/approvals?account=' + accountAddress)
    }
    
  }


export default {
    // Vue.js的插件应当有一个公开方法 install。这个方法的第一个参数是 Vue 构造器，第二个参数是一个可选的选项对象。
    install: function (Vue) {
      Vue.prototype.connectPortal = (param) => connectPortal()
      Vue.prototype.connectMetamask = (param) => connectMetamask()
      Vue.prototype.packageData = (param) => packageData(param)
      Vue.prototype.packageCollectibleData = (param) => packageCollectibleData(param)
      Vue.prototype.jsonToTuple = (param) => jsonToTuple(param)
      Vue.prototype.setApprovalForAll = (param1, param2, param3) => setApprovalForAll(param1, param2, param3)
      Vue.prototype.isApprovedForAll = (p1, p2) => isApprovedForAll(p1, p2)
      Vue.prototype.getId = () => getId()
      Vue.prototype.signature = (order, type, callback) => signature(order, type, callback)
      Vue.prototype.getBalance = (a1, a2) => getBalance(a1, a2)
      Vue.prototype.getEthBalance = (a1, a2) => getEthBalance(a1, a2)
      Vue.prototype.setException = (e, that) => setException(e, that)
      Vue.prototype.toHex = (address) => toHex(address)
      Vue.prototype.packageDetailData = (record) => packageDetailData(record)
      Vue.prototype.approvalPay = (currencyAddress,address,amount,sender)  => approvalPay(currencyAddress,address,amount,sender) 
      Vue.prototype.formateDate = (p1) => formateDate(p1)
      Vue.prototype.tokenToUsdt = (p1,p2) => tokenToUsdt(p1, p2)
      Vue.prototype.addZero = (p1) => addZero(p1)
      Vue.prototype.dealTime = (p1) => dealTime(p1)
      Vue.prototype.assetsType = (p1) => assetsType(p1)
      Vue.prototype.transfer = (p1, p2, p3, p4, p5) => transfer(p1, p2, p3, p4, p5)
      Vue.prototype.transferToken = (p1, p2, p3, p4) => transferToken(p1, p2, p3, p4)
      Vue.prototype.transferEthToken = (p1, p2, p3, p4) => transferEthToken(p1, p2, p3, p4)
      Vue.prototype.objectEmpty = (p1) => objectEmpty(p1)
      Vue.prototype.setApprovalForThis = (p1,p2,p3,p4) => setApprovalForThis(p1,p2,p3,p4)
      Vue.prototype.isApprovedForThis = (p1, p2, p3) => isApprovedForThis(p1 , p2, p3)
      Vue.prototype.packageBoxDetailData = (record) => packageBoxDetailData(record)
      Vue.prototype.isZeroAddress = (address) => isZeroAddress(address)
      Vue.prototype.addTask = (taskObj, transactionHash, logType, callback) => addTask(taskObj, transactionHash, logType, callback)
      Vue.prototype.queryApproveList = (tag, accountAddress) => queryApproveList(tag, accountAddress)
    }
  }